<div id="page-title">
  <div id="page-content" class="inicio" id="transacoes">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="row" *ngIf="!error">
          <div class="container-datepicker col-xs-12">
            <app-datepicker [initialDate]="initialDateFilter" [finalDate]="finalDateFilter" (filter)="setFilterDate($event)"></app-datepicker>
          </div>
        </div>
        <div class="row" *ngIf="!error">
          <div class="col-sm-6">
            <div id="input-tag" class="input textarea caixa-pesquisa">
              <div>
                <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
              </div>
              <div class="filter-icon" (click)="toggleBox()"></div>
              <div [ngClass]="boxHidden ? 'box-hidden' : 'box-show'" class="box-filter">
                <div class="container-box-inner">
                  <label>Bandeira</label>
                  <div *ngFor="let brand of brands">
                    <input (change)="changeTag($event, brand.name)" id={{brand.name}} type="checkbox" class="hidden">
                    <label for={{brand.name}} *ngIf="!brand.actived && transactionsBkp && transactionsBkp.length > 0 && hasBandeiraInTransactions(brand.name)">{{brand.name}}</label>
                  </div>
                </div>
                <div class="container-box-inner">
                  <label>Status</label>
                  <div *ngFor="let s of status">
                    <input (change)="changeTag($event, s.name)" id={{s.name}} type="checkbox" class="styled-checkbox" class="hidden">
                    <label for={{s.name}} *ngIf="!s.actived && transactionsBkp && transactionsBkp.length > 0 && hasStatusInTransactions(s.name)">{{s.name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <button (click)="emitirRelatorio()" class="btn btn-primary pull-right ml-2">Emitir relatório</button>
            <button (click)="buttomRefund()" class="btn btn-primary pull-right" *ngIf="isPagueLaAdmin">Estornar</button>
            </div>
        </div>
        <div *ngIf="!loaded && !error" class="container-loading">
          <div class="btn btn-registrar loading"></div>
        </div>
        <div class="col-md-10 col-md-offset-1" *ngIf="error">
          <span class="error">Nenhuma informação disponível no momento</span>
          <span class="error">Tente novamente mais tarde</span>
        </div>
       
        <table id="master-detail-table" style="width: 100%"></table>
      </div>
    </div>
  </div>
</div>

<app-modal-detail [showModal]="showModal" (eventClose)="eventClose()">
  <div class="modal-header" *ngIf="transaction" [ngClass]="getTransactionStatus(transaction).className">
    <h2>{{ getTransactionStatus(transaction).title }}</h2>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="transaction && transaction.MensagemRetornoAdquirencia && hasError(transaction)">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Motivo</label>
          <p>{{ transaction.MensagemRetornoAdquirencia }}</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Código de Retorno</label>
          <p>{{ transaction.CodigoRetorno }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Cliente</label>
          <p *ngIf="transaction && transaction.NomeCliente">
            {{ transaction.NomeCliente }}
          </p>
          <p *ngIf="transaction && !transaction.NomeCliente && transaction.NomeComprador">
            {{ transaction.NomeComprador }}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Venda</label>
          <p *ngIf="transaction && transaction.Descricao">
            {{ transaction.Descricao }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Nº Venda</label>
          <p *ngIf="transaction && transaction.TransacaoCd">
            {{ transaction.TransacaoCd }}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Comprovante</label>
          <p *ngIf="transaction && (transaction.Tid || transaction.NumeroComprovante)">
            {{ transaction.NumeroComprovante ? transaction.NumeroComprovante : transaction.Tid }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Titular do Cartão</label>
          <p *ngIf="transaction && transaction.NomeCompradorImpressoCartao">
            {{ transaction.NomeCompradorImpressoCartao }}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Data e hora</label>
          <p *ngIf="transaction && transaction.DataRecebimento">
            {{ formatDateAndHour(transaction.DataRecebimento) }}
          </p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="transaction && toNumber(transaction.Parcelas)> 1">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Quantidade de parcelas</label>
          <p *ngIf="transaction && transaction.Parcelas">
            {{ transaction.Parcelas }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label">Cartão</label>
          <p class="info-cartao" *ngIf="transaction && transaction.BandeiraCartao && transaction.NumeroCartao && transaction.DataValidadeCartao">
            <span class="bandeira-cartao master" [ngClass]="getBandeiraClass(transaction.BandeiraCartao)"></span>
            {{ transaction.BandeiraCartao }} *{{ transaction.NumeroCartao }}
            <small>válido até {{ transaction.DataValidadeCartao }}</small>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Valor</label>
          <h4 *ngIf="transaction && transaction.Valor">
            {{ transaction.Valor }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</app-modal-detail>

<app-modal-detail [showModal]="showModalEstorno" (eventClose)="eventCloseEstorno()">
  <div class="modal-header header-estornar">
    <h2 *ngIf="transactionIds && transactionIds.length > 1">Estornar transações</h2>
    <h2 *ngIf="transactionIds && transactionIds.length === 1">Estornar transação</h2>
    <h2 *ngIf="transactionIds && transactionIds.length === 0">Nenhuma transação selecionada</h2>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="errorRefund">
      <svg _ngcontent-c1="" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
        <title _ngcontent-c1="">Transação Reprovada</title>
        <g _ngcontent-c1="" data-name="Camada 2" id="f32c9904-9a49-4b84-a96b-1205778d7e8e">
          <circle _ngcontent-c1="" cx="35" cy="35" r="25" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"></circle>
        </g>
        <g _ngcontent-c1="" data-name="Camada 3" id="5db0cdd3-dede-4fdb-87f7-b5ef7f2d2bf1">
          <line _ngcontent-c1="" class="linha-2" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" x1="24.39" x2="45.61" y1="24.39" y2="45.61"></line>
        </g>
        <g _ngcontent-c1="" data-name="Camada 4" id="fb91e5a3-f581-43de-b27f-420a0e4d440d">
          <line _ngcontent-c1="" class="linha-1" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" x1="45.61" x2="24.39" y1="24.39" y2="45.61"></line>
        </g>
      </svg>
      <p *ngIf="transactionIds && transactionIds.length === 1" class="text-center empty">Não foi possível estornar a transação!</p>
      <p *ngIf="transactionIds && transactionIds.length > 1" class="text-center empty">Não foi possível estornar as transações!</p>
    </div>

    <div class="row" *ngIf="success">
      <svg _ngcontent-c1="" viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
        <title _ngcontent-c1="">Estornado</title>
        <g _ngcontent-c1="" data-name="Círculo Aprovado" id="41c310f0-3cde-4914-9ee4-e4952dc4cf98">
          <circle _ngcontent-c1="" cx="35" cy="35" r="25" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"></circle>
        </g>
        <g _ngcontent-c1="" data-name="Ok Aprovado" id="752bc498-d218-4c7d-b07b-03fcc9fc5d57">
          <polyline _ngcontent-c1="" points="21.74 29.96 33.7 41.88 68.21 15.36" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"></polyline>
        </g>
      </svg>
      <p *ngIf="transactionIds && transactionIds.length === 1" class="text-center empty">A transação foi estornada com sucesso!</p>
      <p *ngIf="transactionIds && transactionIds.length > 1" class="text-center empty">As tranações foram estornadas com sucesso!</p>
    </div>

    <div class="row" *ngIf="!success && !errorRefund">
      <p *ngIf="transactionIds && transactionIds.length === 0" class="text-center empty">Você deve selecionar pelo menos uma transação</p>
      <p *ngIf="transactionIds && transactionIds.length === 1" class="text-center empty">Tem certeza de que deseja<br>estornar a transação selecionada?</p>
      <p *ngIf="transactionIds && transactionIds.length > 1" class="text-center empty">Tem certeza de que deseja<br>estornar as transações selecionadas?</p>
      <div class="btn-action" *ngIf="transactionIds && transactionIds.length > 0">
        <button class="btn btn-estornar" (click)="refund()" *ngIf="!refunding">Estornar</button>
        <button class="btn btn-primary loading" *ngIf="refunding"></button>
        <button class="btn btn-default" (click)="eventCloseEstorno()">Cancelar</button>
      </div>
    </div>
  </div>
</app-modal-detail>
